export default {
  stats: {
    table: {
      rank: "Classement",
      name: "Nom",
    },
    legend: {
      title: "Légende",
    },
    filters: {
      titles: {
        week: "Semaine",
        round: "Ronde",
        split: "Split",
      },
      options: {
        all: "Tout",
        qualifier: {
          cumulativeStats: "Total",
          perGame: "Par match",
        },
      },
    },
  },
};
